import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "tw-text-base sm:tw-text-lg tw-font-semibold tw-text-slate-900 tw-mr-4 tw-inline-block" }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = ["title"]
const _hoisted_5 = { class: "tw-text-sm tw-text-slate-600 tw-inline-block" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "tw--m-5" }
const _hoisted_9 = { class: "tw-relative tw-z-30 tw-rounded-xl tw-border tw-border-slate-200/70 tw-bg-white/60 tw-backdrop-blur tw-shadow-sm tw-p-3 tw-mb-4" }
const _hoisted_10 = { class: "tw-flex tw-flex-col tw-gap-3 sm:tw-flex-row sm:tw-items-center sm:tw-justify-between" }
const _hoisted_11 = { class: "tw-min-w-0 tw-flex-1 tw-overflow-x-auto tw-flex tw-flex-nowrap tw-items-center tw-gap-2" }
const _hoisted_12 = {
  key: 0,
  class: "tw-flex tw-flex-nowrap tw-gap-2 tw-pb-1 sm:tw-pb-0"
}
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "tw-inline-flex tw-min-w-[15px] tw-justify-center tw-px-1.5 tw-py-0.5 tw-text-[15px]" }
const _hoisted_15 = { class: "tw-inline-flex tw-h-5 tw-min-w-[1.25rem] tw-line-height-1tw-items-center tw-justify-center tw-rounded-full tw-bg-slate-600 tw-px-1 tw-font-bold tw-text-white" }
const _hoisted_16 = {
  key: 1,
  class: "tw-flex tw-flex-nowrap tw-gap-2"
}
const _hoisted_17 = { class: "tw-px-1.5 tw-bg-white/20 tw-rounded-full" }
const _hoisted_18 = { class: "tw-px-1.5 tw-bg-white/20 tw-rounded-full" }
const _hoisted_19 = { class: "tw-flex tw-items-center tw-gap-3 tw-flex-shrink-0" }
const _hoisted_20 = {
  key: 0,
  class: "tw-flex tw-items-center tw-gap-2"
}
const _hoisted_21 = { class: "tw-flex tw-items-center tw-gap-3 tw-text-xs tw-text-slate-600 tw-flex-shrink-0" }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { class: "tw-flex tw-items-center tw-gap-2" }
const _hoisted_24 = ["value", "onChange"]
const _hoisted_25 = ["value"]
const _hoisted_26 = {
  key: 0,
  class: "tw-mt-2 tw-pt-2 tw-border-t tw-border-slate-100 tw-text-[11px] tw-text-slate-500"
}
const _hoisted_27 = { class: "tw-font-bold tw-text-slate-800" }
const _hoisted_28 = { class: "tw-mt-4" }
const _hoisted_29 = {
  key: 0,
  class: "tw-p-10 tw-text-center"
}
const _hoisted_30 = {
  key: 0,
  class: "tw-mt-6 tw-flex tw-justify-center"
}
const _hoisted_31 = {
  key: 1,
  class: "tw-p-8 tw-text-center"
}
const _hoisted_32 = { class: "tw-max-w-md tw-mx-auto tw-bg-white tw-rounded-2xl tw-p-6 tw-shadow-sm tw-border tw-border-slate-200" }
const _hoisted_33 = { class: "tw-text-xl tw-font-bold tw-text-slate-900 tw-mb-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SearchInput = _resolveComponent("SearchInput")!
  const _component_EnterContainer = _resolveComponent("EnterContainer")!
  const _component_TrackingHeader = _resolveComponent("TrackingHeader")!
  const _component_CopyButton = _resolveComponent("CopyButton")!
  const _component_ContainerModal = _resolveComponent("ContainerModal")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_AddNotesModal = _resolveComponent("AddNotesModal")!
  const _component_HourGlass = _resolveComponent("HourGlass")!
  const _component_EventSchedule = _resolveComponent("EventSchedule")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_AdvancedSort = _resolveComponent("AdvancedSort")!
  const _component_Button = _resolveComponent("Button")!
  const _component_ContainerTable = _resolveComponent("ContainerTable")!
  const _component_ListPage = _resolveComponent("ListPage")!
  const _component_PaginationBar = _resolveComponent("PaginationBar")!
  const _component_Profile = _resolveComponent("Profile")!
  const _directive_tippy = _resolveDirective("tippy")!

  return (_openBlock(), _createBlock(_component_ListPage, {
    variant: "page",
    loading: _ctx.mainLoading && !_ctx.isBackgroundActiveContainersRefreshing,
    loadingText: "Loading…",
    pageSize: _ctx.pageSize,
    "onUpdate:pageSize": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.pageSize) = $event))
  }, {
    default: _withCtx(({ pageSizeOptions, setPageSize }) => [
      (_ctx.user.onboardedTerminalLogins)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_TrackingHeader, {
              class: "tw-mb-4",
              isShowingAppointments: _ctx.isShowingAppointments,
              onRefresh: _ctx.refreshContainers,
              onToggleAppointments: _ctx.toggleAppointmentsView
            }, {
              search: _withCtx(() => [
                _createVNode(_component_SearchInput, {
                  modelValue: _ctx.searchInput,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchInput) = $event)),
                  onSearch: _ctx.searchTermChanged,
                  placeholder: "Search container, BL, customer…",
                  class: "tw-w-full"
                }, null, 8, ["modelValue", "onSearch"])
              ]),
              actions: _withCtx(() => [
                _createVNode(_component_EnterContainer, {
                  onSearchTermChanged: _ctx.searchTermChanged,
                  onContainerListChanged: _ctx.refreshContainers,
                  hideSearch: true
                }, null, 8, ["onSearchTermChanged", "onContainerListChanged"])
              ]),
              _: 1
            }, 8, ["isShowingAppointments", "onRefresh", "onToggleAppointments"]),
            _createVNode(_component_Modal, {
              isOpen: _ctx.isContainerModalOpen,
              "onUpdate:isOpen": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isContainerModalOpen) = $event)),
              modalId: "tracking-container-modal",
              maxWidth: "7xl",
              ariaLabel: "Container details"
            }, {
              title: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  (_ctx.currentContainerFromList)
                    ? (_openBlock(), _createBlock(_component_CopyButton, {
                        key: 0,
                        value: String(_ctx.currentContainerFromList.containerId),
                        mode: "wrap-content",
                        title: "Copy container ID",
                        "aria-label": "Copy container ID to clipboard"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.currentContainerFromList.containerId), 1)
                        ]),
                        _: 1
                      }, 8, ["value"]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_3, "Container")),
                  (_ctx.currentContainerFromList?.isCancelled)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 2,
                        class: "tw-ml-2 tw-inline-flex tw-items-center tw-rounded-md tw-bg-rose-50 tw-px-2 tw-py-0.5 tw-text-xs tw-font-medium tw-text-rose-800 tw-ring-1 tw-ring-inset tw-ring-rose-600/20",
                        title: _ctx.currentContainerFromList.cancelledReason || 'Cancelled on order'
                      }, " Cancelled ", 8, _hoisted_4))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_5, [
                  (_ctx.currentContainerFromList?.billOfLading)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
                        _cache[17] || (_cache[17] = _createTextVNode(" BL# ", -1)),
                        _createVNode(_component_CopyButton, {
                          value: _ctx.currentContainerFromList.billOfLading.billOfLadingNumber,
                          mode: "wrap-content",
                          title: "Copy B/L number",
                          "aria-label": "Copy B/L number to clipboard"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.currentContainerFromList.billOfLading.billOfLadingNumber), 1)
                          ]),
                          _: 1
                        }, 8, ["value"])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.currentContainerFromList?.bookingNumber)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                        _cache[18] || (_cache[18] = _createTextVNode(" Booking # ", -1)),
                        _createVNode(_component_CopyButton, {
                          value: _ctx.currentContainerFromList.bookingNumber,
                          mode: "wrap-content",
                          title: "Copy Booking number",
                          "aria-label": "Copy Booking number to clipboard"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.currentContainerFromList.bookingNumber), 1)
                          ]),
                          _: 1
                        }, 8, ["value"])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              content: _withCtx(() => [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_ContainerModal, {
                    containerId: _ctx.currentContainerId,
                    containerFromList: _ctx.currentContainerFromList,
                    onClose: _ctx.closeContainerModal,
                    onUpdateContainer: _ctx.onContainerUpdated,
                    enableVessel: true,
                    vessels: _ctx.vessels,
                    onArchiveContainer: _ctx.archiveContainer,
                    onShowOrder: _ctx.showOrder,
                    onShowNewOrder: _ctx.showNewOrder
                  }, null, 8, ["containerId", "containerFromList", "onClose", "onUpdateContainer", "vessels", "onArchiveContainer", "onShowOrder", "onShowNewOrder"])
                ])
              ]),
              _: 1
            }, 8, ["isOpen"]),
            _createVNode(_component_AddNotesModal, {
              open: _ctx.containerNotesModalOpen,
              title: "Container notes",
              subtitle: _ctx.containerForNotesModal ? String(_ctx.containerForNotesModal.containerId) : undefined,
              container: _ctx.containerForNotesModal,
              onClose: _ctx.closeContainerNotes,
              onAddedNote: _ctx.onContainerNotesAdded,
              onArchivedNotesUpdated: _ctx.onContainerArchivedNotesUpdated
            }, null, 8, ["open", "subtitle", "container", "onClose", "onAddedNote", "onArchivedNotesUpdated"]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  (!_ctx.isShowingAppointments)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(['All', 'Unknown', 'NotFound', 'Onboard', 'NotAvailable', 'Available', 'OffDock'].filter(s => s !== 'Unknown' || _ctx.stats.unknown > 0), (status) => {
                          return (_openBlock(), _createElementBlock("button", {
                            key: status,
                            type: "button",
                            class: _normalizeClass(["tw-inline-flex tw-items-center tw-gap-2 tw-rounded-full tw-border tw-px-3 tw-py-1.5 tw-font-medium tw-transition tw-whitespace-nowrap tw-text-[17px]", 'tw-border-slate-200 tw-text-slate-700 '
                    +
                      (_ctx.currentStatus === status
                      ? 'tw-text-white ' + (({'Unknown': 'tw-bg-amber-700 ', 'NotFound': 'tw-bg-orange-700', 'Onboard': 'tw-bg-blue-700 ', 'NotAvailable': 'tw-bg-red-700', 'Available': 'tw-bg-emerald-700', 'OffDock': 'tw-bg-slate-700'})[status] || 'tw-bg-slate-700')
                      : (({'Unknown': 'tw-bg-amber-100 hover:tw-bg-amber-300 ', 'NotFound': 'tw-bg-orange-100 hover:tw-bg-orange-300', 'Onboard': 'tw-bg-blue-100 hover:tw-bg-blue-300', 'NotAvailable': 'tw-bg-red-200 hover:tw-bg-red-300', 'Available': 'tw-bg-emerald-100 hover:tw-bg-emerald-300', 'OffDock': 'tw-bg-slate-100 hover:tw-bg-slate-300'})[status] || ''))]),
                            onClick: ($event: any) => (_ctx.changeStatus(status))
                          }, [
                            _createElementVNode("span", null, _toDisplayString(status === 'NotAvailable' ? 'Not Available' : status === 'NotFound' ? 'Not Found' : status === 'OffDock' ? 'Off Dock' : status), 1),
                            _createElementVNode("span", _hoisted_14, _toDisplayString(status === 'All' ? _ctx.stats.all : 
                     status === 'Onboard' ? _ctx.stats.onboard : 
                     status === 'Available' ? _ctx.stats.available : 
                     status === 'NotAvailable' ? _ctx.stats.notAvailable : 
                     status === 'OffDock' ? _ctx.stats.offDock : 
                     status === 'NotFound' ? _ctx.stats.notFound : _ctx.stats.unknown), 1)
                          ], 10, _hoisted_13))
                        }), 128)),
                        (_ctx.containerNumbersChangedSincePageLoad.length + _ctx.containerNumbersAddedSincePageLoad.length > 0)
                          ? (_openBlock(), _createElementBlock("label", {
                              key: 0,
                              class: _normalizeClass(["tw-inline-flex tw-items-center tw-gap-2 tw-rounded-full tw-border tw-mx-4 tw-px-2 tw-py-1.5 tw-font-medium tw-text-[14px] tw-transition tw-whitespace-nowrap tw-cursor-pointer", _ctx.isShowChangedAndNewContainersOnly ? 'tw-bg-red-700 tw-text-white' : 'tw-bg-red-400'])
                            }, [
                              _withDirectives(_createElementVNode("input", {
                                type: "checkbox",
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.isShowChangedAndNewContainersOnly) = $event))
                              }, null, 512), [
                                [_vModelCheckbox, _ctx.isShowChangedAndNewContainersOnly]
                              ]),
                              _cache[19] || (_cache[19] = _createTextVNode(" NEW ", -1)),
                              _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.containerNumbersChangedSincePageLoad.length + _ctx.containerNumbersAddedSincePageLoad.length), 1)
                            ], 2))
                          : _createCommentVNode("", true)
                      ]))
                    : (_ctx.isShowingAppointments)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                          _createElementVNode("button", {
                            type: "button",
                            class: _normalizeClass(["tw-inline-flex tw-items-center tw-gap-2 tw-rounded-full tw-border tw-px-3 tw-py-1.5 tw-text-xs tw-font-medium tw-transition", _ctx.currentStatus === _ctx.TERMINAL_APPOINTMENTS_STRING ? 'tw-bg-slate-900 tw-text-white' : 'tw-border-slate-200 tw-bg-white/60']),
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.changeStatus(_ctx.TERMINAL_APPOINTMENTS_STRING)))
                          }, [
                            _createVNode(_component_HourGlass, { class: "tw-w-3 tw-h-3" }),
                            _cache[20] || (_cache[20] = _createElementVNode("span", null, "Terminal appts", -1)),
                            _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.stats.terminalAppointments || 0), 1)
                          ], 2),
                          _createElementVNode("button", {
                            type: "button",
                            class: _normalizeClass(["tw-inline-flex tw-items-center tw-gap-2 tw-rounded-full tw-border tw-px-3 tw-py-1.5 tw-text-xs tw-font-medium tw-transition", _ctx.currentStatus === _ctx.DELIVERY_APPOINTMENTS_STRING ? 'tw-bg-slate-900 tw-text-white' : 'tw-border-slate-200 tw-bg-white/60']),
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.changeStatus(_ctx.DELIVERY_APPOINTMENTS_STRING)))
                          }, [
                            _createVNode(_component_EventSchedule, { class: "tw-w-3 tw-h-3" }),
                            _cache[21] || (_cache[21] = _createElementVNode("span", null, "Delivery appts", -1)),
                            _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.stats.deliveryAppointments || 0), 1)
                          ], 2)
                        ]))
                      : _createCommentVNode("", true),
                  (_ctx.isListFiltered)
                    ? _withDirectives((_openBlock(), _createElementBlock("button", {
                        key: 2,
                        type: "button",
                        class: "tw-inline-flex tw-items-center tw-gap-2 tw-rounded-full tw-border tw-border-slate-200 tw-bg-rose-400 tw-text-white tw-px-3 tw-py-1.5 tw-font-medium tw-text-slate-700 tw-transition tw-whitespace-nowrap tw-text-[17px] hover:tw-bg-rose-700",
                        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.resetListFilters && _ctx.resetListFilters(...args)))
                      }, [
                        _createVNode(_component_font_awesome_icon, { icon: "filter-circle-xmark" })
                      ])), [
                        [_directive_tippy, {content: 'Reset active search/category filters', placement: 'top'}]
                      ])
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_19, [
                  (_ctx.isExportSelectionMode)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_20, [
                        _withDirectives((_openBlock(), _createElementBlock("button", {
                          class: _normalizeClass(["tw-relative tw-flex tw-items-center tw-gap-2 tw-px-2 tw-py-2 tw-backdrop-blur tw-border tw-rounded-xl tw-shadow-sm tw-transition-all tw-text-sm tw-font-medium", [_ctx.exportSelectionFormat === 'csv' ? 'tw-bg-slate-600 tw-text-white' : 'tw-border-slate-200']]),
                          onClick: _cache[6] || (_cache[6] = ($event: any) => {_ctx.exportSelectionFormat = 'csv'; _ctx.isExportSelectionModalOpen = true;})
                        }, [...(_cache[22] || (_cache[22] = [
                          _createTextVNode(" CSV ", -1)
                        ]))], 2)), [
                          [_directive_tippy, {content: 'Preview/Copy', placement: 'bottom'}]
                        ]),
                        _withDirectives((_openBlock(), _createElementBlock("button", {
                          class: _normalizeClass(["tw-relative tw-flex tw-items-center tw-gap-2 tw-px-2 tw-py-2 tw-backdrop-blur tw-border tw-rounded-xl tw-shadow-sm tw-transition-all tw-text-sm tw-font-medium", [_ctx.exportSelectionFormat === 'text' ? 'tw-bg-slate-600 tw-text-white' : 'tw-border-slate-200']]),
                          onClick: _cache[7] || (_cache[7] = ($event: any) => {_ctx.exportSelectionFormat = 'text'; _ctx.isExportSelectionModalOpen = true;})
                        }, [...(_cache[23] || (_cache[23] = [
                          _createTextVNode(" Text ", -1)
                        ]))], 2)), [
                          [_directive_tippy, {content: 'Preview/Copy', placement: 'bottom'}]
                        ]),
                        _withDirectives((_openBlock(), _createElementBlock("button", {
                          class: _normalizeClass(["tw-relative tw-flex tw-items-center tw-gap-2 tw-px-2 tw-py-2 tw-backdrop-blur tw-border tw-rounded-xl tw-shadow-sm tw-transition-all tw-text-sm tw-font-medium", [_ctx.exportSelectionFormat === 'html' ? 'tw-bg-slate-600 tw-text-white' : 'tw-border-slate-200']]),
                          onClick: _cache[8] || (_cache[8] = ($event: any) => {_ctx.exportSelectionFormat = 'html'; _ctx.isExportSelectionModalOpen = true;})
                        }, [...(_cache[24] || (_cache[24] = [
                          _createTextVNode(" HTML ", -1)
                        ]))], 2)), [
                          [_directive_tippy, {content: 'Export/Download', placement: 'bottom'}]
                        ]),
                        _cache[27] || (_cache[27] = _createTextVNode("   ", -1)),
                        _withDirectives((_openBlock(), _createElementBlock("button", {
                          class: _normalizeClass(["tw-px-2 tw-py-2 tw-backdrop-blur tw-border tw-rounded-xl tw-shadow-sm tw-transition-all tw-text-sm tw-font-medium", [_ctx.exportSelectionColumnMode === 'single' ? 'tw-bg-slate-600 tw-text-white' : 'tw-border-slate-200']]),
                          onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.exportSelectionColumnMode = 'single'))
                        }, [
                          _createVNode(_component_font_awesome_icon, {
                            icon: "bars",
                            class: _normalizeClass(["tw-h-3.5 tw-w-3.5 tw-z-10 tw-text-slate-800", [_ctx.exportSelectionColumnMode === 'single' ? 'tw-bg-slate-600 tw-text-white' : 'tw-border-slate-200']])
                          }, null, 8, ["class"]),
                          _cache[25] || (_cache[25] = _createElementVNode("span", { class: "tw-pl-0.5" }, "1", -1))
                        ], 2)), [
                          [_directive_tippy, {content: 'Single Column Mode', placement: 'bottom'}]
                        ]),
                        _withDirectives((_openBlock(), _createElementBlock("button", {
                          class: _normalizeClass(["tw-px-2 tw-py-2 tw-backdrop-blur tw-border tw-rounded-xl tw-shadow-sm tw-transition-all tw-text-sm tw-font-medium", [_ctx.exportSelectionColumnMode === 'multiple' ? 'tw-bg-slate-600 tw-text-white' : 'tw-border-slate-200']]),
                          onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.exportSelectionColumnMode = 'multiple'))
                        }, [
                          _createVNode(_component_font_awesome_icon, {
                            icon: "bars",
                            class: _normalizeClass(["tw-h-3.5 tw-w-3.5 tw-z-10 tw-text-slate-800", [_ctx.exportSelectionColumnMode === 'multiple' ? 'tw-bg-slate-600 tw-text-white' : 'tw-border-slate-200']])
                          }, null, 8, ["class"]),
                          _cache[26] || (_cache[26] = _createElementVNode("span", { class: "tw-pl-0.5" }, "∞", -1))
                        ], 2)), [
                          [_directive_tippy, {content: 'Multiple Column Mode', placement: 'bottom'}]
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("button", {
                    class: _normalizeClass(["tw-relative tw-flex tw-items-center tw-gap-2 tw-px-4 tw-py-2 tw-backdrop-blur tw-border tw-rounded-xl tw-shadow-sm tw-transition-all tw-text-sm tw-font-medium", [_ctx.isExportSelectionMode ? 'tw-bg-black tw-text-white' : '']]),
                    onClick: _cache[11] || (_cache[11] = ($event: any) => {_ctx.isExportSelectionMode = !_ctx.isExportSelectionMode; if (!_ctx.isExportSelectionMode) { _ctx.isExportSelectionModalOpen = false; }})
                  }, [
                    _createVNode(_component_font_awesome_icon, {
                      icon: "download",
                      class: _normalizeClass(["tw-h-3.5 tw-w-3.5 tw-text-slate-800", [_ctx.isExportSelectionMode ? 'tw-bg-black tw-text-white' : '']])
                    }, null, 8, ["class"]),
                    _cache[28] || (_cache[28] = _createTextVNode(" Export ", -1)),
                    (_ctx.isExportSelectionMode)
                      ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                          key: 0,
                          icon: "circle-xmark",
                          class: "tw-h-2.5 tw-w-2.5 tw-z-100 tw-text-slate-800 tw-absolute tw-top-[-5px] tw-right-[-5px]"
                        }))
                      : _createCommentVNode("", true)
                  ], 2),
                  _cache[29] || (_cache[29] = _createElementVNode("span", { class: "tw-text-slate-300" }, "|", -1)),
                  _createVNode(_component_AdvancedSort, {
                    availableFields: _ctx.containerSortFields,
                    modelValue: _ctx.multiSort,
                    "onUpdate:modelValue": [
                      _cache[12] || (_cache[12] = ($event: any) => ((_ctx.multiSort) = $event)),
                      _ctx.handleAdvancedSort
                    ],
                    isActive: _ctx.isAdvancedSort,
                    onActivate: _ctx.reactivateAdvancedSort
                  }, null, 8, ["availableFields", "modelValue", "isActive", "onUpdate:modelValue", "onActivate"])
                ]),
                _createElementVNode("div", _hoisted_21, [
                  (!_ctx.isActiveContainersLoading)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (_ctx.totalPages > 1)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_22, "Page " + _toDisplayString(_ctx.pageNum + 1) + " of " + _toDisplayString(_ctx.totalPages), 1))
                          : _createCommentVNode("", true),
                        _cache[31] || (_cache[31] = _createElementVNode("span", { class: "tw-text-slate-300" }, "|", -1)),
                        _createElementVNode("label", _hoisted_23, [
                          _cache[30] || (_cache[30] = _createElementVNode("span", null, "Rows", -1)),
                          _createElementVNode("select", {
                            class: "tw-rounded-md tw-border-slate-200 tw-bg-white tw-px-1.5 tw-py-0.5 tw-outline-none",
                            value: String(_ctx.pageSize),
                            onChange: (e) => setPageSize(Number((e.target as HTMLSelectElement).value))
                          }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pageSizeOptions, (opt) => {
                              return (_openBlock(), _createElementBlock("option", {
                                key: opt,
                                value: String(opt)
                              }, _toDisplayString(opt), 9, _hoisted_25))
                            }), 128))
                          ], 40, _hoisted_24)
                        ])
                      ], 64))
                    : _createCommentVNode("", true)
                ])
              ]),
              (_ctx.searchTerm)
                ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                    _cache[32] || (_cache[32] = _createTextVNode(" Searching for: ", -1)),
                    _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.searchTerm), 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_28, [
              _createVNode(_component_ListPage, {
                ref: "listPageRef",
                variant: "card",
                "selection-items": _ctx.containers,
                "selection-key": 'id',
                "enable-selection": true,
                loading: _ctx.isActiveContainersLoading,
                loadingText: "Loading containers…",
                cardPadding: false
              }, {
                default: _withCtx(({ selection }) => [
                  (!_ctx.isActiveContainersLoading && (_ctx.containers || []).length === 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                        _cache[34] || (_cache[34] = _createElementVNode("div", { class: "tw-text-lg tw-font-semibold tw-text-slate-900 tw-mb-1" }, "No containers found", -1)),
                        _cache[35] || (_cache[35] = _createElementVNode("div", { class: "tw-text-sm tw-text-slate-600 tw-mb-4" }, "Try adjusting filters or search.", -1)),
                        _createVNode(_component_Button, {
                          onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.changeStatus('All')))
                        }, {
                          default: _withCtx(() => [...(_cache[33] || (_cache[33] = [
                            _createTextVNode("Show all", -1)
                          ]))]),
                          _: 1
                        })
                      ]))
                    : (_openBlock(), _createBlock(_component_ContainerTable, {
                        key: 1,
                        onRefreshContainers: _ctx.refreshContainers,
                        onArchiveContainer: _ctx.archiveContainer,
                        containers: _ctx.currentTabContainers,
                        isHideCustomerInfo: !_ctx.user.enableCustomerInfo,
                        containerNumbersAddedSincePageLoad: _ctx.containerNumbersAddedSincePageLoad,
                        containerNumbersChangedSincePageLoad: _ctx.containerNumbersChangedSincePageLoad,
                        lastOpenedContainerId: _ctx.lastOpenedContainerId,
                        sortBy: _ctx.sortBy,
                        sortOrder: _ctx.sortOrder,
                        onUpdateSortBy: _ctx.updateSortBy,
                        onSelectContainer: _ctx.selectContainer,
                        onOpenContainerNotes: _ctx.openContainerNotes,
                        typeOfAppointmentsShowing: !_ctx.isShowingAppointments ? '' : (_ctx.currentStatus === _ctx.DELIVERY_APPOINTMENTS_STRING ? 'delivery' : 'terminal'),
                        selectionApi: {
              enabled: selection.enabled,
              keys: selection.keys,
              count: selection.count,
              allSelected: selection.allSelected,
              someSelected: selection.someSelected,
              toggleKey: selection.toggleKey,
              toggleAll: selection.toggleAll,
              isSelected: selection.isSelected,
              clearSelection: selection.clearSelection
            },
                        isExportSelectionMode: _ctx.isExportSelectionMode,
                        exportSelectionColumnMode: _ctx.exportSelectionColumnMode,
                        exportSelectionFormat: _ctx.exportSelectionFormat,
                        "onUpdate:exportSelectionFormat": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.exportSelectionFormat) = $event)),
                        isExportSelectionModalOpen: _ctx.isExportSelectionModalOpen,
                        "onUpdate:isExportSelectionModalOpen": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.isExportSelectionModalOpen) = $event))
                      }, null, 8, ["onRefreshContainers", "onArchiveContainer", "containers", "isHideCustomerInfo", "containerNumbersAddedSincePageLoad", "containerNumbersChangedSincePageLoad", "lastOpenedContainerId", "sortBy", "sortOrder", "onUpdateSortBy", "onSelectContainer", "onOpenContainerNotes", "typeOfAppointmentsShowing", "selectionApi", "isExportSelectionMode", "exportSelectionColumnMode", "exportSelectionFormat", "isExportSelectionModalOpen"]))
                ]),
                _: 1
              }, 8, ["selection-items", "loading"])
            ]),
            (_ctx.totalPages > 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                  _createVNode(_component_PaginationBar, {
                    page: _ctx.pageNum,
                    totalPages: _ctx.totalPages,
                    disabled: _ctx.isActiveContainersLoading,
                    onPreviousPage: _ctx.prevPage,
                    onNextPage: _ctx.nextPage,
                    onGoToPage: _ctx.goToPage
                  }, null, 8, ["page", "totalPages", "disabled", "onPreviousPage", "onNextPage", "onGoToPage"])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (!_ctx.mainLoading && !_ctx.user.onboardedTerminalLogins)
        ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("h2", _hoisted_33, "Welcome, " + _toDisplayString(_ctx.user.firstName) + "!", 1),
              _cache[36] || (_cache[36] = _createElementVNode("p", { class: "tw-text-slate-600 tw-mb-6" }, " Please enter your terminal logins so we can fetch your containers for you. ", -1)),
              _createVNode(_component_Profile, { onRefreshContainers: _ctx.refreshContainers }, null, 8, ["onRefreshContainers"])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["loading", "pageSize"]))
}